import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Privacy Policy';
    var description = 'RegScale Privacy Policy';
    var keywords = 'RegScale, privacy, policy, cookies';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
